import Model, { toProp } from "./Model";

/**
 *
 * @class DocumentCategory
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.8] app/src/model/DocumentCategory.js
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

class DocumentCategory extends Model {
  constructor(modelData) {
    super()

    /** @type string */
    this.id = toProp()

    /** @type string */
    this.key = toProp()

    /** @type string */
    this.name = toProp()

    /** @type string */
    this.type = toProp()

    this.buildModel(modelData)
  }
}

export default DocumentCategory